import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

const LightDarkToggle = () => {
  const [theme, setTheme] = useState<"light" | "dark">("light");

  React.useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    const newTheme =
      storedTheme === "dark" || storedTheme === "light"
        ? storedTheme
        : window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";

    document.documentElement.classList.toggle("dark", newTheme === "dark");
    document.documentElement.classList.toggle("light", newTheme === "light");
    setTheme(newTheme);
  }, []);

  const item = {
    title: theme === "light" ? "Dark theme" : "Light theme",
    icon: theme === "light" ? <SunIcon /> : <MoonIcon />,
    color: "bg-teal-300 dark:bg-teal-800",
    onclick: () => onChangeThemeClick(),
  };

  const onChangeThemeClick = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);

    if (newTheme === "dark") {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
    } else {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    }
    localStorage.setItem("theme", newTheme);
  };

  return (
    <div className="relative group">
      <div
        className="flex items-center justify-center rounded-lg cursor-pointer w-fit transition-colors hover:bg-slate-200 dark:hover:bg-[#4a1978]"
        title={item.title}
        aria-label={item.title}
        onClick={item.onclick}
      >
        <div
          className={"h-10 w-10 flex items-center justify-center rounded-lg "}
        >
          <div className="w-3/5 text-gray-800 h-3/5 dark:text-violet-100 dark:group-hover:text-white">
            {item.icon}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LightDarkToggle;
